export function getSolveColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "crossTitle",
            headerName: "Title",
            flex: 1,
            editable: false,
            alignItems: "center",
            renderCell: (params) => params.row?.cross?.title ?? "",
        },
        {
            field: "startedAt",
            headerName: "Started",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "finishedAt",
            headerName: "Finished",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "percentage",
            headerName: "Percentage",
            flex: 0.8,
            editable: false,
            alignItems: "center",
            type: "number",
            renderCell: (params) => {
                return `${params.value}%`;
            },
        },
        {
            field: "isCompleted",
            headerName: "Completed",
            flex: 0.8,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return params.value ? "Yes" : "No";
            },
        },
        {
            field: "attemptsCount",
            headerName: "Attempts",
            flex: 0.8,
            editable: false,
            alignItems: "center",
            type: "number",
        },
        {
            field: "hintUsed",
            headerName: "Hints (words)",
            flex: 1.2,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                const v = params.value;
                if (v == null || v === "") return "";
                return String(v).replace(/\n/g, ", ");
            },
        },
    ];
}

